module.exports = __webpack_public_path__ + "img/vi.eba83084.png";